import { render, staticRenderFns } from "./Baixa.vue?vue&type=template&id=1f077dbe&"
import script from "./Baixa.vue?vue&type=script&lang=js&"
export * from "./Baixa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports